import { invalidateQuoteHeaderQueryKey } from '@frontend/api';

export const invalidateQuoteHeader = (
  quoteNumberWithRevision?: string | null,
) => {
  if (!quoteNumberWithRevision) return Promise.resolve();
  return invalidateQuoteHeaderQueryKey(quoteNumberWithRevision);
};
